import { DOCS_MENU } from "../web/src/lib/docs-menu-flat";

const EVENT_DATE_URL_CUTOFF = "2/10/2023";

// see: web/helpers.js

/**
 * Generate a path from the document with a slug.
 * @param {*} param0
 * @returns {string}
 */
export const pageDocPath = ({
  _type = "",
  slug = {},
  startDate,
  recurring,
  customPath,
  company,
  videoId,
  prospect,
  menu,
  menuParent,
  title,
  name,
  series,
}) => {
  const uncommonPrefix = "/uncommon";
  const type = videoId ? "video" : _type;
  let date;
  let useDate;

  switch (type) {
    case "author":
      return getAuthorPath(name);

    case "post":
      return `/blog/${slug.current}/`;

    case "prospect":
      return `/hello/${slug.current}/`;

    case "asset":
      return `/resources/${slug.current}/`;

    case "playbook":
      return `/playbooks/${slug.current}/`;

    case "documentation":
      return `/docs/${getArticlePath({
        parentId: menu,
        slug: slug.current,
        menuParent,
      })}`;

    case "company":
      return `/hello/${slug.current}/`;

    case "story":
      return `/customers/${slug.current}/`;

    case "offering":
      return `/${slug.current}/`;

    case "signal":
      return `/resources/signals/${slug.current}/`;

    case "signalSource":
      return `/prompts/${slug.current}/`;

    case "agent":
      return `/chat/${slug.current}/`;

    case "prompt":
      return `/prompts/${slug.current}/`;

    case "scenario":
      return `/scenarios/${slug.current}/`;

    case "glossary":
      return `/glossary/${slug.current}/`;

    case "competitor":
      return `/compare/${slug.current}/`;

    case "invite":
      return `/events/${slug.current}/`;

    case "training":
      return `/academy/${series?.[0]?.slug?.current}/${slug.current}/`;

    case "integration":
      return `/integrations/${module.exports.textToSlug(
        company.toLowerCase()
      )}/`;

    case "event":
      date = new Date(startDate);
      useDate = !recurring && new Date(EVENT_DATE_URL_CUTOFF) - date > 0;

      return `${uncommonPrefix}/events/${useDate ? `${module.exports.formatDate(date)}--` : ""
        }${slug.current}/`;

    case "page":
      return `/${slug.current === "/" ? "" : `${slug.current}/`}`;

    // @note required for sitemap
    case "category":
      return customPath ? `/${slug.current}/` : `/resources/${slug.current}/`;

    case "video":
      return videoId ? `/videos/${slug}/` : `/videos/${slug.current}/`;

    case "account":
      return `/research/${title.replace(/\s+/g, "-").toLowerCase()}/`;

    case "competeDB":
      return `/compare/${title.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}/ai/`;

    case "redirect":
      return slug.current;

    default:
      return slug.current || "";
  }
};

const getArticlePath = ({ parentId, slug, menuParent }) => {
  const path = [];
  let currentItem = DOCS_MENU.find((item) => item.id === parentId);

  while (currentItem) {
    path.unshift(currentItem.slug || currentItem.id);
    if (!currentItem.parent) break;
    currentItem = DOCS_MENU.find((item) => item.id === currentItem.parent);
  }

  return path.length ? `${path.join("/")}/${menuParent ? "" : `${slug}/`}` : "";
};

export const getAuthorPath = (name) => {
  if (!name) return null;
  const slug = name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
  return `/blog/authors/${slug}/`;
};
